import React from "react";
import { useResources } from "../Providers/ResourcesProvider/ResourceProvider";

function FogSolutionPP() {
  const { texts } = useResources();
  const sections = Array.isArray(texts.privacyPolicySections)
    ? texts.privacyPolicySections
    : [];

  return (
    <div className="container-pp">
      <div className="container-pp-content">
        <h1 className="App-title" style={{ marginBottom: "20px" }}>
          {texts.privacyPolicyTitle}
        </h1>
        {texts.privacyPolicyUpdatedAt}
        <div style={{ display: "flex", flexDirection: "column", gap: "28px" }}>
          {sections.map((section, index) => (
            <section key={`${section.heading}-${index}`}>
              <h2 className="App-title" style={{ fontSize: "1.5rem" }}>
                {section.heading}
              </h2>
              {(section.paragraphs || []).map((paragraph, pIdx) => (
                <p key={`${index}-${pIdx}`} className="App-subtitle">
                  {paragraph}
                </p>
              ))}
            </section>
          ))}{" "}
        </div>
      </div>
    </div>
  );
}

export default FogSolutionPP;
